import { meetsContrastGuidelines } from 'polished';
import useLocalTranslation from './useLocalTranslation';

const useContrastChecker = () => {
  const translate = useLocalTranslation();
  const updateContrastWarning = (backgroundColor: any, foregroundColor: any) => {
    try {
      const meetsContrastGuide = meetsContrastGuidelines(backgroundColor, foregroundColor).AA;
      if (meetsContrastGuide) {
        return '';
      } else {
        return translate('contrast_warning', backgroundColor, foregroundColor);
      }
    } catch (error) {
      console.log('Error occurred while checking the contrast color');
    }
    return '';
  };
  return updateContrastWarning;
};

export default useContrastChecker;
